import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  Type,
  ViewChild,
  ViewChildren,
  ViewContainerRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  IonInfiniteScroll,
  ModalController,
  PopoverController,
} from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { fromEvent, Observable, Subscription } from "rxjs";
import { Animations } from "src/app/_helpers/animations";
import { globalHelper } from "src/app/_helpers/global";
import { RowsLoaderService } from "../../../_services/rows-loader.service";
import { ModalSelectDropdownComponent } from "../modal-select-dropdown/modal-select-dropdown.component";
import { ModalSelectDropdownSettings } from "../modal-select-dropdown/modal-select-dropdown.model";
import { PopoverOptions } from "../popover/popover.model";
import { DataRowComponent } from "./data-row.component";
import { PaginationClientSideOptions } from "./pagination-client-side-options";
import { PaginationColumn } from "./pagination-column.class";

@Component({
  selector: "app-pagination-client-side",
  templateUrl: "./pagination-client-side.component.html",
  styleUrls: [
    "./pagination-client-side.component.scss",
    "./../../../_styles/ion-grid-content-table.scss",
  ],
  animations: [Animations.animeHeight, Animations.animeRotate],
  providers: [RowsLoaderService],
})
export class PaginationClientSideComponent
  implements OnInit, OnDestroy, AfterViewInit {
  @Input()
  componentRef: Type<any>;

  @Input()
  options: PaginationClientSideOptions = new PaginationClientSideOptions();

  @Input()
  columns: PaginationColumn[] = [];

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  headerEmitClick: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  rowsLoaderReady: EventEmitter<RowsLoaderService> = new EventEmitter<RowsLoaderService>();

  @ViewChildren("rowTemplate", { read: ViewContainerRef })
  rowsHost: QueryList<ViewContainerRef>;

  @ViewChild("contenttable", { read: ElementRef })
  gridElement: ElementRef;

  @ViewChild(IonInfiniteScroll)
  infiniteScroll: IonInfiniteScroll;

  intervalInitGrid: any;
  listSlidedDown: boolean = true;

  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;
  components = [];
  mobileView: boolean = false;

  currentSortDisplay: string;
  sortPossibles = [];
  currentSortColumn: string = "";
  currentSortDir: string = "";

  currentSort;

  showPastHeader: boolean = false;
  showTodayHeader: boolean = false;
  showTomorrowHeader: boolean = false;
  showWeekHeader: boolean = false;
  showLaterHeader: boolean = false;

  firstLoadSortFlag: boolean = true;

  routingSubscription: Subscription;

  ascSort: string;
  descSort: string;
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private router: Router,
    public rowsLoader: RowsLoaderService,
    private translateService: TranslateService,
    private changeDetector: ChangeDetectorRef,
    public popoverController: PopoverController,
    public modalCtrl: ModalController,
    private activatedRoute: ActivatedRoute
  ) {}

  async ngOnInit() {
    this.mobileView = this.calcMobileView();

    // /** Initialize options with default values */
    // this.options = {
    //   ...new PaginationClientSideOptions(),
    //   ...this.options,
    // };

    if (this.options.mainStyle) {
      this.options.styleClasses.push(this.options.mainStyle);
    }

    this.ascSort = this.translateService.instant("SORT_ASC");
    this.descSort = this.translateService.instant("SORT_DESC");

    this.sortPossibles = [];
    this.columns.forEach((column) => {
      if (column.sortableMobile === undefined) {
        column.sortableMobile = column.sortable;
      }
      if (column.sortableMobile) {
        {
          this.sortPossibles.push({
            name:
              this.translateService.instant(column.displayName) +
              " (" +
              this.ascSort +
              ")",
            value: {
              column: column,
              dir: this.ascSort,
            },
          });
          this.sortPossibles.push({
            name:
              this.translateService.instant(column.displayName) +
              " (" +
              this.descSort +
              ")",
            value: {
              column: column,
              dir: this.descSort,
            },
          });
        }
      }
    });

    this.resizeObservable$ = fromEvent(window, "resize");
    this.resizeSubscription$ = this.resizeObservable$.subscribe((evt) => {
      this.mobileView = this.calcMobileView();
      let state = this.calcMobileView();

      for (let i in this.components) {
        this.components[i].instance.displayMobileView = state;
      }
    });

    this.intervalInitGrid = setInterval(() => {
      this.initPaginationGrid();
    }, 25);

    this.routingSubscription = this.activatedRoute.params.subscribe((val) => {
      this.firstLoadSortFlag = true;
    });
  }

  ngAfterViewInit() {
    this.rowsLoader.paginationComponent = this;

    this.rowsLoaderReady.emit(this.rowsLoader);

    this.changeDetector.detectChanges();
  }

  addDynamicComponentAuto(rowIndex) {
    if (!this.rowsHost || this.rowsHost.length == 0 || !this.componentRef) {
      return;
    }

    let factory = this.componentFactoryResolver.resolveComponentFactory(
      this.componentRef
    );
    let container = this.rowsHost.first;

    this.addDynamicComponent(container, factory, rowIndex);
  }

  calcMobileView(): boolean {
    return this.options.mobileViewBreakPoint > window.innerWidth;
  }

  addDynamicComponent(
    container: ViewContainerRef,
    factory: ComponentFactory<any>,
    rowIndex
  ) {
    if (!container || !factory) {
      return;
    }
    let row = this.rowsLoader.rowsVisible[rowIndex];
    let componetInstance = container.createComponent(factory);
    if (this.options.groupDateKey && this.rowsLoader.isNoProblemSortingColumn(this.options.noProblemDateKeys)) {
      (<DataRowComponent>(
        componetInstance.instance
      )).dateKeySeparator = this.addDateHeader(row);
    }

    (<DataRowComponent>componetInstance.instance).row = row;
    (<DataRowComponent>(
      componetInstance.instance
    )).displayMobileView = this.calcMobileView();

    (<DataRowComponent>(
      componetInstance.instance
    )).actionButton = this.options.actionButton;

    (<DataRowComponent>(
      componetInstance.instance
    )).actionButtonDisabled = this.options.actionButtonDisabled;

    (<DataRowComponent>(
      componetInstance.instance
    )).styleClass = this.options.mainStyle;
    (<DataRowComponent>(
      componetInstance.instance
    )).customData = this.options.customData;

    (<DataRowComponent>(
      componetInstance.instance
    )).spaceType = this.options.spaceType;

    //Subscribe refresh request
    const sub: Subscription = (<DataRowComponent>(
      componetInstance.instance
    )).refreshRequest.subscribe((event) => this.refreshRequest.emit());

    //Subscribe action request
    const subAction: Subscription = (<DataRowComponent>(
      componetInstance.instance
    )).actionRequest.subscribe((event) => this.actionRequest.emit(event));

    (<DataRowComponent>(
      componetInstance.instance
    )).withAssignment = this.options.withAssignment;

    componetInstance.onDestroy(() => {
      sub.unsubscribe();
      subAction.unsubscribe();
    });

    this.components.push(componetInstance);
  }

  onHeaderEmitClick() {
    if (this.options.headerEmitClick === true) {
      this.headerEmitClick.emit();
    }
  }

  refreshComponentsReferences(): boolean {
    if (!this.rowsHost || this.rowsHost.length == 0 || !this.componentRef) {
      return false;
    }

    let factory = this.componentFactoryResolver.resolveComponentFactory(
      this.componentRef
    );
    let container = this.rowsHost.first;
    this.components = [];
    container.clear();

    if (this.rowsLoader.rowsVisible.length == 0) {
      return false;
    }

    for (let i in this.rowsLoader.rowsVisible) {
      this.addDynamicComponent(container, factory, i);
    }

    this.resetDateHeaders();

    if (this.firstLoadSortFlag) {
      this.columns.filter((column) => {
        if (column.initSortDirection == "ASC") {
          setTimeout(() => {
            this.changeSort(column.name, this.ascSort);
          }, 0);
          this.firstLoadSortFlag = false;
        }
        if (column.initSortDirection == "DESC") {
          setTimeout(() => {
            this.changeSort(column.name, this.descSort);
          }, 0);
          this.firstLoadSortFlag = false;
        }
      });
    }

    return true;
  }

  initPaginationGrid() {
    if (!this.gridElement) {
      return;
    }

    let columnsCount = this.options.gridColumnsCount
      ? parseInt(this.options.gridColumnsCount.toString())
      : 12;

    if (this.options.headerAddLink || this.options.removeElementAction) {
      columnsCount += this.options.headerAddRemoveColSize;
    }

    this.gridElement.nativeElement.style.setProperty(
      "--ion-grid-columns",
      columnsCount.toString()
    );

    clearInterval(this.intervalInitGrid);
  }

  async removeAction(id: number) {
    await this.options.removeElementAction(id);
  }

  navigateToElement(id: number) {
    if (!this.options.routerLinkBase) {
      return;
    }

    this.router.navigateByUrl(this.options.routerLinkBase + id);
  }

  loadRows(event) {
    window.setTimeout(() => {
      if (!this.rowsLoader.showMoreRows()) {
        event.target.disabled = true;
      }

      event.target.complete();
    }, 500);
  }

  toggleList() {
    this.listSlidedDown = !this.listSlidedDown;
  }

  async showSort() {
    let modalSettings: ModalSelectDropdownSettings = {
      data: this.sortPossibles,
      currentValue: this.currentSort,
      header: "SORT_LOWER",
      placeholder: "CHOOSE_COLUMN",
      valueRequied: false,
      buttonText: "SORT_LOWER",
    };

    const modal = this.modalCtrl.create({
      component: ModalSelectDropdownComponent,
      componentProps: {
        modalSettings: modalSettings,
        clearButton: true,
      },
      cssClass: "add-edit-modal add-edit-modal--small",
    });
    (await modal).present();
    this.sortChange((await (await modal).onDidDismiss()).data);
  }

  changeSort(column: string, dir: string) {
    this.rowsLoader.sort(column, dir);

    this.currentSortColumn = column;
    this.currentSortDir = dir;
  }

  sortChange(event) {
    if (!event) {
      return;
    }

    if (event === "clearEvent" || event?.length === 0) {
      this.currentSortDisplay = "";
      this.currentSort = null;
      this.refreshRequest.emit();
      return;
    }

    this.currentSortDisplay = event.name;
    this.currentSort = event;
    this.changeSort(event.value.column.name, event.value.dir);
  }

  addDateHeader(row) {
    const today = new Date(new Date().setHours(0, 0, 0, 0));
    const dayMiliseconds = 86400000;
    const sevenDaysMiliseconds = 604800000;
    let dateHeader: string;

    const currentInstanceDate = new Date(
      new Date(row[this.options.groupDateKey]).setHours(0, 0, 0, 0)
    );

    if (currentInstanceDate.getTime() < today.getTime()) {
      if (this.showPastHeader == false) {
        this.showPastHeader = true;
        dateHeader = this.translateService.instant("SPACE.RESERVATION_PAST");
      }
    } else if (currentInstanceDate.getTime() === today.getTime()) {
      if (this.showTodayHeader == false) {
        this.showTodayHeader = true;
        dateHeader = this.translateService.instant("SPACE.RESERVATION_TODAY");
      }
    } else if (
      currentInstanceDate.getTime() - dayMiliseconds ==
      today.getTime()
    ) {
      if (this.showTomorrowHeader == false) {
        this.showTomorrowHeader = true;
        dateHeader = this.translateService.instant(
          "SPACE.RESERVATION_TOMORROW"
        );
      }
    } else if (
      currentInstanceDate.getTime() - dayMiliseconds > today.getTime() &&
      currentInstanceDate.getTime() - sevenDaysMiliseconds < today.getTime()
    ) {
      if (this.showWeekHeader == false) {
        this.showWeekHeader = true;
        dateHeader = this.translateService.instant("SPACE.RESERVATION_WEEK");
      }
    } else if (
      currentInstanceDate.getTime() - sevenDaysMiliseconds >=
      today.getTime()
    ) {
      if (this.showLaterHeader == false) {
        this.showLaterHeader = true;
        dateHeader = this.translateService.instant(
          "SPACE.RESERVATION_FUTURE"
        );
      }
    }
    return dateHeader;
  }

  resetDateHeaders() {
    this.showPastHeader = false;
    this.showTodayHeader = false;
    this.showTomorrowHeader = false;
    this.showWeekHeader = false;
    this.showLaterHeader = false;
  }

  async onShowInfo(event: Event, legendArray) {

    const popover: PopoverOptions = await globalHelper.Popover(
      this.popoverController,
      event,
      [],
      "user-assignment-view-share__popover",
      ...legendArray
    );
  }
  // "user-assignment-view-share__popover",
  // "Twoje miejsce zostanie udostępnione dla wszystkich użytkowników. Dodatkową opcją jest możliwość wyboru użytkownika mogącego korzystać z tego miejsca."

  ngOnDestroy() {
    if (this.resizeSubscription$) {
      this.resizeSubscription$.unsubscribe();
    }
    if (this.routingSubscription) {
      this.routingSubscription.unsubscribe();
    }

    if (this.rowsLoader) {
      this.rowsLoader.clear();
    }

    clearInterval(this.intervalInitGrid);
  }
}
